// src/components/ProductForm.jsx
import React, { useMemo, useState, useEffect } from "react";

const FIELD_META = [
  { key:"id", label:"ID", readOnly:true },
  { key:"ExternalID", label:"External ID" },
  { key:"DistributorCode", label:"Distributor Code" },
  { key:"DistributorName", label:"Distributor Name", type:"textarea" },
  { key:"Manufacturer", label:"Manufacturer", type:"textarea" },
  { key:"ManufacturerCode", label:"Manufacturer Code" },
  { key:"ManufacturerName", label:"Manufacturer Name", type:"textarea" },
  { key:"Importer", label:"Importer", type:"textarea" },
  { key:"CountryOfOrigin", label:"Country of Origin" },
  { key:"Thickness", label:"Thickness" },
  { key:"Width", label:"Width" },
  { key:"Height", label:"Height" },
  { key:"UnitOfMeasure", label:"UoM" },
  { key:"NetWeightKgPerUnit", label:"Net Wt. (kg/unit)" },
  { key:"Packaging", label:"Packaging" },
  { key:"QuantityPerPackage", label:"Qty/Package" },
  { key:"Density", label:"Density" },
  { key:"Category", label:"Category" },
  { key:"SubCategory", label:"Sub Category" },
  { key:"Surface", label:"Surface" },
  { key:"DecorGroup", label:"Decor Group" },
  { key:"DecorCode", label:"Decor Code" },
  { key:"Structure", label:"Structure" },
  { key:"PhotoNote", label:"Photo Note", type:"textarea" },
  { key:"Application", label:"Application", type:"textarea" },
  { key:"ApplicationAndMaintenanceInstructions", label:"App & Maint. Instr.", type:"textarea" },
  { key:"DiscountedPrice", label:"Discounted Price", type:"number" },
  { key:"OriginalPrice", label:"Original Price", type:"number" },
  { key:"URL", label:"URL", type:"url" },
  { key:"Availability", label:"Availability" },
  { key:"CurrentPrice", label:"Current Price", type:"number", step:"0.01" },
  { key:"NumberInStock", label:"In Stock", type:"number" },
  { key:"PriceCurrency", label:"Currency" },
  { key:"Function", label:"Function" },
  { key:"ThicknessValue", label:"Thickness (value)", type:"number", step:"0.01" },
];

export default function ProductForm({ initial = {}, onSave, onCancel }) {
  const [form, setForm] = useState(() => ({ ...initial }));

  useEffect(() => {
    setForm({ ...initial });
  }, [initial]);

  const setField = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const onSubmit = (e) => {
    e.preventDefault();
    onSave?.(form);
  };

  const groups = useMemo(() => ({
    // lagano grupisanje po tipu radi lepšeg layout-a
    main: FIELD_META.slice(0, 18),
    details: FIELD_META.slice(18, 27),
    pricing: FIELD_META.slice(27),
  }), []);

  const renderField = (f) => {
    const val = form[f.key] ?? "";
    const common = {
      id: f.key,
      name: f.key,
      value: val,
      onChange: (e) => setField(f.key, e.target.value),
      className: "w-full px-3 py-2 border rounded dark:bg-neutral-800 dark:text-white",
      disabled: f.readOnly,
      placeholder: f.label,
    };
    if (f.type === "textarea") {
      return <textarea {...common} rows={3} />;
    }
    return <input type={f.type || "text"} {...common} step={f.step} />;
  };

  return (
    <form onSubmit={onSubmit} className="bg-white dark:bg-neutral-800 p-4 rounded shadow space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-semibold">{form.id ? "Edit Product" : "Add Product"}</h3>
        <div className="flex gap-2">
          <button type="button" onClick={onCancel} className="px-3 py-2 rounded border">Cancel</button>
          <button type="submit" className="px-4 py-2 rounded bg-primary-light text-white hover:bg-primary-dark">Save</button>
        </div>
      </div>

      {/* Basic */}
      <section>
        <h4 className="font-semibold mb-2">Basic</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {groups.main.map(f => (
            <label key={f.key} className="space-y-1">
              <span className="text-sm text-gray-600 dark:text-gray-300">{f.label}</span>
              {renderField(f)}
            </label>
          ))}
        </div>
      </section>

      {/* Details */}
      <section>
        <h4 className="font-semibold mb-2">Details</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {groups.details.map(f => (
            <label key={f.key} className="space-y-1">
              <span className="text-sm text-gray-600 dark:text-gray-300">{f.label}</span>
              {renderField(f)}
            </label>
          ))}
        </div>
      </section>

      {/* Pricing & stock */}
      <section>
        <h4 className="font-semibold mb-2">Pricing & Stock</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {groups.pricing.map(f => (
            <label key={f.key} className="space-y-1">
              <span className="text-sm text-gray-600 dark:text-gray-300">{f.label}</span>
              {renderField(f)}
            </label>
          ))}
        </div>
      </section>
    </form>
  );
}
